import { Link } from "react-router-dom";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const services = [
  {
    icon: "ri-traffic-light-line",
    title: "交通誘導",
    desc: "工事現場等において通行人や地域住民の方々、作業員の皆様など、あらゆる人員の安全を確保し、作業のスムーズな進行を実現すべく、的確な案内・誘導業務を実施しています。",
  },
  {
    icon: "ri-roadster-line",
    title: "高速道路警備",
    desc: "高速道路での警備は新規参入のハードルが高く非常に難しい専門領域です。その高速道路上での工事を安全に進めるための車線規制や誘導といった特殊な業務を担っています。",
  },
  {
    icon: "ri-fire-line",
    title: "イベント警備（雑踏警備）",
    desc: "各種イベントやコンサート、花火大会など多くの来場者や車両が集まる場所において、事故防止のために来場者の誘導や安全確保業務、車両の誘導・規制等の業務を実施しています。",
  },
  {
    icon: "ri-building-4-line",
    title: "施設警備",
    desc: "マンションやビル・様々な施設の恒久的な防犯・防災のため、教育を受けた専門の警備スタッフによる警戒・監視・巡回業務を実施しています。",
  },
];

export default function ServicesSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section id="service" className="bg-white py-20 md:py-28">
      <div ref={ref} className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-gold text-sm tracking-[4px] font-bold block mb-2">SERVICE</span>
          <h2 className="text-2xl md:text-3xl font-bold text-navy">事業内容</h2>
          <div className="w-16 h-1 bg-gold mx-auto mt-4 rounded-full" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((item, i) => (
            <div
              key={item.title}
              className={`bg-white rounded-2xl p-6 md:p-8 border border-gray-200 transition-all duration-700 hover:border-gold hover:shadow-lg ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="w-20 h-20 mx-auto rounded-full bg-[#f5ecd7] flex items-center justify-center mb-5">
                <span className="w-10 h-10 flex items-center justify-center text-navy">
                  <i className={`${item.icon} text-3xl`}></i>
                </span>
              </div>
              <h3 className="text-lg font-bold text-navy text-center mb-4">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-6">{item.desc}</p>
              <div className="text-center">
                <Link
                  to="/business"
                  className="inline-flex items-center gap-1 text-[#1A0DAB] font-bold text-sm transition-all duration-200 hover:underline whitespace-nowrap"
                >
                  詳しく見る
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}